export default __webpack_public_path__ + "static/media/req_change_success.2f0c8eec.png";